import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="discount-code"
export default class extends Controller {

  static values = {
    currentLanguage: String,
    templates: Object,
    discountCode: String,
    currentDiscountCodeLanguage: String,
    pendingDiscountCodes: Array,
    reserveUrl: String,
  }

  static targets = [
    'emailTemplateDutch',
    'emailTemplateEnglish',
    'emailTemplateGerman',
    'emailSubject',
    'emailBody',
    'name',
    'discountCodeId',
  ]

  connect() {
    this.currentLanguageValue = 'dutch';
    this.selectLanguage();
    $(this.nameTarget).on('keyup', () => {
      this.selectLanguage.bind(this)();
    });
  }

  setLanguage(element) {
    const language = element.srcElement.dataset.language;
    this.currentLanguageValue = language;

    if (language == "german") {
      $(`#DE-country-button`).click();
    } else if (language == "dutch") {
      $(`#NL-country-button`).click();
    }
    this.selectLanguage();
  }

  setCurrentDiscountCode(element) {

    const description = element.srcElement.dataset.description;
    const country = element.srcElement.dataset.country;

    if (description == null || country == null) {
      return;
    }

    this.currentDiscountCodeLanguageValue = country;
    this.currentDiscountCodeValue = description;
    this.getDiscountCode(description);
  }

  getDiscountCode(description) {
    
    let params = new URLSearchParams({
      description: description,
      country: this.currentDiscountCodeLanguageValue,
    });
    let url = this.reserveUrlValue + '.json?' + params.toString();

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
    .then(response => response.json())
    .then(data => {
      if (data.discount_code) {
        this.discountCodeValue = data.discount_code.code;
        this.discountCodeIdTarget.value = data.discount_code.id;
        $('.description-button').removeClass('btn-danger');
        $('.description-button').removeClass('btn-primary');
        let id = this.currentDiscountCodeLanguageValue + '-' + data.discount_code.description.replace(/\s+/g, '_') + '-button';
        $(`#${id}`).addClass('btn-primary');
        let previous_count = parseInt($(`#${id}`).find('.count').text().split('(')[1].split(')')[0]);
        let new_count = previous_count - 1;

        if (new_count == 0) {
          $(`#${id}`).addClass('btn-danger').removeClass('btn-primary').removeClass('btn-secondary');
        } else {
          $(`#${id}`).addClass('btn-secondary').removeClass('btn-danger');
        }
        $(`#${id}`).find('.count').text('(' + new_count + ')');

        this.selectLanguage();
        $('#submit-button').prop('disabled', false);
      } else if (data.error) {
        $('.description-button').removeClass('btn-primary').removeClass('btn-secondary');
        let id = this.currentDiscountCodeLanguageValue + '-'  + description.replace(/\s+/g, '_') + '-button';
        $(`#${id}`).addClass('btn-danger');
        $(`#${id}`).find('.count').text(data.error);
        this.discountCodeValue = '[NO DISCOUNT CODE AVAILABLE]';
        this.selectLanguage();
      }
    });
  }

  selectLanguage() {
    $('.language-button').removeClass('btn-primary');
    $(`#${this.currentLanguageValue}-button`).addClass('btn-primary');

    this.emailSubjectTarget.value = this.subjectForLanguage(this.currentLanguageValue);

    $('.summernote').summernote('code', this.bodyForLanguage(this.currentLanguageValue));  
  }

  bodyForLanguage(language) {
    let body = '';  
    switch (language) {
      case 'dutch':
        body = this.templatesValue.dutch;
        break;
      case 'english':
        body = this.templatesValue.english;
        break;
      case 'german':
        body = this.templatesValue.german;
        break;
        default:
        body = '';
        break;
    }
    body = body.replace('[NAME]', $(this.nameTarget).val());
    if (this.discountCodeValue) {
      body = body.replace('[DISCOUNT_CODE]', this.discountCodeValue);
    }
    return body;
  }

  subjectForLanguage(language) {
    switch (language) { 
      case 'dutch':
        return 'Jouw persoonlijke kortingscode van one2track';
      case 'english':
        return 'Your personal discount code from one2track';
      case 'german':
        return 'Dein persönlicher Rabattcode von one2track';
    }
  }
}
